import React from 'react'
import { useTranslation } from 'react-i18next'
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { formatNumber } from '~/utils/helpers'

interface SliderChartProps {
  data: any
}

const SliderChart: React.FC<SliderChartProps> = ({ data }) => {
  const { t } = useTranslation()

  return <ResponsiveContainer width='100%' height={300}>
    <LineChart
      width={500}
      height={300}
      data={data?.map(value => ({ name: t('Value'), value: value.value }))}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      <CartesianGrid strokeDasharray='3 3' />
      <XAxis dataKey='name' />
      <YAxis allowDecimals={false} />
      <Tooltip formatter={(value, name) => [formatNumber(value), name]} />
      <Legend />
      <Line type='monotone' dataKey='value' stroke='#82ca9d' />
    </LineChart>
  </ResponsiveContainer>
}
export default SliderChart